import { EditTableThemeSizeConfig } from './types';

const medium: EditTableThemeSizeConfig = {
  EditTable: {},
};

export default medium;
